function convertNameToRuLocale(title: string | null | undefined): string {
    if (!title) return '';

    return title;
}

export default convertNameToRuLocale;
